<script lang="ts">
	import Fa from 'svelte-fa';
	import { faPlay } from '@fortawesome/free-solid-svg-icons';
	interface Props {
		tipType?: string;
		avatar: string;
		nameStreamer: string;
		amount: number | string;
		received: string;
		tertiary?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		tipType = 'text',
		avatar,
		nameStreamer,
		amount,
		received,
		tertiary = false,
		children
	}: Props = $props();

	const buttonClasses = [
		'btn-icon',
		tertiary ? 'bg-tertiary-500' : 'bg-primary-500',
		'text-white dark:text-white'
	];
</script>

<div>
	<div
		class="flex max-w-sm flex-col items-center justify-center rounded-2xl border-[3px] bg-transparent {tertiary
			? 'border-tertiary-500'
			: 'border-primary-500'} p-3"
	>
		<div class="flex flex-col items-center space-y-2">
			<div class="flex flex-row items-center space-x-3">
				<div
					class="rounded-2xl border-2 p-1 text-sm/3 {tertiary
						? 'border-tertiary-500 text-tertiary-500'
						: 'border-primary-500 text-primary-500'}"
				>
					{tipType === 'text' ? 'Text Tip' : 'Voice Tip'}
				</div>
				<div><img src={avatar} alt="card img" /></div>
			</div>
			<h4 class="text-base/3 font-semibold">{nameStreamer}</h4>
			<div class="text-center text-sm text-secondary-700 dark:text-secondary-200">
				<p>{@render children?.()}</p>
			</div>
			{#if tipType === 'voice'}
				<div>
					<span class={buttonClasses.join(' ')}>
						<Fa icon={faPlay} size="2x" class="p-1" />
					</span>
				</div>
			{/if}
			<div class="text-sm text-secondary-200 dark:text-secondary-700">{amount} - {received}</div>
		</div>
	</div>
</div>
